import type { MouseEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Tag, type TagProps } from 'antd';
import styled from 'styled-components';

type Props = TagProps & {
  relation: 'and' | 'or';
  showsRelation: boolean;
  isLast: boolean;
  onClose?: (event: MouseEvent<HTMLElement>) => void;
  onChangeRelation?: (relation: 'and' | 'or') => void;
};

const FilterChip = ({
  children,
  relation,
  showsRelation,
  isLast,
  onClose,
  onChangeRelation,
}: Props): ReactNode => {
  const { t } = useTranslation();

  return (
    <>
      <Tag
        closable
        color="blue"
        style={{ padding: '0 4px', margin: 0 }}
        onClose={(event: MouseEvent<HTMLElement>): void => {
          event.stopPropagation();
          onClose?.(event);
        }}
      >
        {children}
      </Tag>
      {!isLast &&
        showsRelation &&
        (onChangeRelation ? (
          <RelationSelector
            value={relation}
            onChange={onChangeRelation}
            options={[
              { value: 'or', label: t('or') },
              { value: 'and', label: t('and') },
            ]}
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ textTransform: 'uppercase' }}
            placement="bottomRight"
          />
        ) : (
          <RelationLabel>{t(relation)}</RelationLabel>
        ))}
    </>
  );
};

const RelationLabel = styled.div`
  display: inline-block;
  opacity: 0.4;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  height: 22px;
  line-height: 22px;
  margin-left: 4px;
  margin-right: -2px;
`;

const RelationSelector = styled(Select<'and' | 'or'>)`
  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 22px;
    padding: 0 4px;
    align-items: center;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-item {
    padding-right: 12px;
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 1;
  }

  .ant-select-selection-item {
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    opacity: 0.4;
  }

  .ant-select-arrow {
    top: calc(50% + 1px);
    right: 4px;
  }
`;

export { FilterChip };
